<template>
  <div class="layout h-100">
    <header class="page-topbar" id="header">
      <div class="navbar navbar-fixed">
        <nav
          class="navbar-main navbar-color nav-collapsible sideNav-lock navbar-dark gradient-45deg-indigo-purple no-shadow"
        >
          <div class="nav-wrapper">
            <ul class="navbar-list right">
              <li class="hide-on-large-only">
                <a
                  class="waves-effect waves-block waves-light search-button"
                  href="javascript:void(0);"
                >
                  <i class="material-icons">search</i>
                </a>
              </li>
              <li>
                <a
                  class="waves-effect waves-block waves-light profile-button"
                  href="javascript:void(0);"
                  data-target="profile-dropdown"
                >
                  <span class="avatar-status avatar-online">
                    <img src="/assets/images/avatar/avatar.svg" alt="avatar" />
                  </span>
                </a>
              </li>
            </ul>
            <!-- notifications-dropdown-->
            <ul class="dropdown-content" id="notifications-dropdown">
              <li>
                <h6>
                  NOTIFICATIONS
                  <span class="new badge">5</span>
                </h6>
              </li>
              <li class="divider"></li>
              <li>
                <a class="grey-text text-darken-2" href="#!">
                  <span class="material-icons icon-bg-circle cyan small">add_shopping_cart</span> A new order has been placed!
                </a>
                <time class="media-meta" datetime="2015-06-12T20:50:48+08:00">2 hours ago</time>
              </li>
              <li>
                <a class="grey-text text-darken-2" href="#!">
                  <span class="material-icons icon-bg-circle red small">stars</span> Completed the task
                </a>
                <time class="media-meta" datetime="2015-06-12T20:50:48+08:00">3 days ago</time>
              </li>
              <li>
                <a class="grey-text text-darken-2" href="#!">
                  <span class="material-icons icon-bg-circle teal small">settings</span> Settings updated
                </a>
                <time class="media-meta" datetime="2015-06-12T20:50:48+08:00">4 days ago</time>
              </li>
              <li>
                <a class="grey-text text-darken-2" href="#!">
                  <span class="material-icons icon-bg-circle deep-orange small">today</span> Director meeting started
                </a>
                <time class="media-meta" datetime="2015-06-12T20:50:48+08:00">6 days ago</time>
              </li>
              <li>
                <a class="grey-text text-darken-2" href="#!">
                  <span class="material-icons icon-bg-circle amber small">trending_up</span> Generate monthly report
                </a>
                <time class="media-meta" datetime="2015-06-12T20:50:48+08:00">1 week ago</time>
              </li>
            </ul>
            <!-- profile-dropdown-->
            <ul class="dropdown-content" id="profile-dropdown">
              <!-- <li><a class="grey-text text-darken-1" href="page-faq.html"><i class="material-icons">help_outline</i> Help</a></li> -->
              <!-- <li class="divider"></li> -->
              <li>
                <a
                  class="grey-text text-darken-1 pointer"
                  @click="$router.push({path:'/change-password'})"
                >
                  <!-- <i class="material-icons">lock_outline</i> -->
                  Change Password
                </a>
              </li>
              <li>
                <a @click="logout()" class="grey-text text-darken-1">
                  <!-- <i class="material-icons">keyboard_tab</i>  -->
                  Logout
                </a>
              </li>
            </ul>
          </div>
          <nav class="display-none search-sm">
            <div class="nav-wrapper">
              <form>
                <div class="input-field">
                  <input class="search-box-sm" type="search" required />
                  <label class="label-icon" for="search">
                    <i class="material-icons search-sm-icon">search</i>
                  </label>
                  <i class="material-icons search-sm-close">close</i>
                </div>
              </form>
            </div>
          </nav>
        </nav>
      </div>
    </header>
    <aside
      :class="{'sidenav-main nav-lock nav-collapsible sidenav-light sidenav-active-square':true,'nav-collapsed':showFullNav, 'nav-expanded' : !showFullNav}"
      style="height: calc(100% - 64px);overflow: auto;"
    >
      <div class="brand-sidebar">
        <h1 class="logo-wrapper">
          <!-- /assets/images/logo/materialize-logo-color.png -->
          <a class="brand-logo darken-1 pointer" @click="$router.push({path:'/app/dashboard'})">
            <img src="/assets/images/logo/logo.png" alt="materialize logo" />
            <span class="logo-text hide-on-med-and-down">Home Care</span>
          </a>
          <!-- <a class="navbar-toggler" @click="showFullNav= !showFullNav">
            <i class="material-icons">menu</i>
          </a> -->
        </h1>
      </div>
      <ul
        class="sidenav sidenav-collapsible leftside-navigation collapsible sidenav-fixed menu-shadow"
        id="slide-out"
        data-menu="menu-navigation"
        data-collapsible="menu-accordion"
      >
        <li value="dashboard" :class="{'active' : this.$route.name == 'dashboard'}" class="bold">
          <a class="waves-effect waves-cyan" @click="$router.push({path:'/app/dashboard'})">
            <i class="material-icons">dashboard</i>
            <span class="menu-title" data-i18n>Dashboard</span>
          </a>
        </li>
        <li value="subadmin" :class="{'active' : this.$route.name == 'sub-admin'}" class="bold">
          <a class="waves-effect waves-cyan" @click="$router.push({path:'/app/sub-admin'})">
            <i class="material-icons">person</i>
            <span class="menu-title" data-i18n>Sub Admin</span>
          </a>
        </li>
        <li value="services" class="navigation-header">
          <a class="navigation-header-text">Services</a>
          <i class="navigation-header-icon material-icons">more_horiz</i>
        </li>
        <li
          value="service_category"
          class="bold"
          :class="{'active' : this.$route.name == 'service-category'}"
        >
          <a
            class="waves-effect waves-cyan pointer"
            @click="$router.push({path:'/app/service-category'})"
          >
            <i class="material-icons">assignment</i>
            <span class="menu-title" data-i18n>Service Category</span>
          </a>
        </li>
        <li
          value="manage_services"
          class="bold"
          :class="{'active' : (this.$route.name == 'manage-services' || this.$route.name == 'add-service' || this.$route.name == 'update-service' || this.$route.name == 'service')}"
        >
          <a class="waves-effect waves-cyan" @click="$router.push({path:'/app/manage-services'})">
            <i class="material-icons">assessment</i>
            <span class="menu-title" data-i18n>Manage Services</span>
          </a>
        </li>
        <li value="service_bookings" class="navigation-header">
          <a class="navigation-header-text">Service Bookings</a>
          <i class="navigation-header-icon material-icons">more_horiz</i>
        </li>
        <li
          value="packages"
          class="bold"
          :class="{'active' : this.$route.name == 'service-packages'}"
        >
          <a
            class="waves-effect waves-cyan pointer"
            @click="$router.push({path:'/app/service-packages'})"
          >
            <i class="material-icons">store</i>
            <span class="menu-title" data-i18n>Packages</span>
          </a>
        </li>
        <li
          value="audits"
          class="bold"
          :class="{'active' : this.$route.name == 'service-audits' || this.$route.name == 'audits-detail'}"
        >
          <a
            class="waves-effect waves-cyan pointer"
            @click="$router.push({path:'/app/service-audits'})"
          >
            <i class="material-icons">group_work</i>
            <span class="menu-title" data-i18n>Audits</span>
          </a>
        </li>
        <li
          value="bookings"
          class="bold"
          :class="{'active' : this.$route.name == 'service-bookings' || this.$route.name == 'booking-detail'}"
        >
          <a
            class="waves-effect waves-cyan pointer"
            @click="$router.push({path:'/app/service-bookings'})"
          >
            <i class="material-icons">credit_card</i>
            <span class="menu-title" data-i18n>Bookings</span>
          </a>
        </li>
        <li value="reviews" class="bold" :class="{'active' : this.$route.name == 'reviews'}">
          <a class="waves-effect waves-cyan pointer" @click="$router.push({path:'/app/reviews'})">
            <i class="material-icons">forum</i>
            <span class="menu-title" data-i18n>Reviews</span>
          </a>
        </li>
        <li value="vendors" class="navigation-header">
          <a class="navigation-header-text">Vendors</a>
          <i class="navigation-header-icon material-icons">more_horiz</i>
        </li>
        <!-- <li
          value="vendors"
          class="bold"
          :class="{'active' : (this.$route.name == 'add-vendor' || this.$route.name == 'update-vendor')}"
        >
          <a
            class="waves-effect waves-cyan pointer"
            @click="$router.push({path:'/app/add-vendor'})"
          >
            <i class="material-icons">group_add</i>
            <span class="menu-title" data-i18n>Add/Update Vendor</span>
          </a>
        </li> -->
        <li value="vendors" class="bold" :class="{'active' : this.$route.name == 'vendors'}">
          <a class="waves-effect waves-cyan pointer" @click="$router.push({path:'/app/vendors'})">
            <i class="material-icons">recent_actors</i>
            <span class="menu-title" data-i18n>Manage Vendors</span>
          </a>
        </li>
        <li value="payments" class="navigation-header">
          <a class="navigation-header-text">Payments</a>
          <i class="navigation-header-icon material-icons">more_horiz</i>
        </li>
        <li value="pay_ins" class="bold" :class="{'active' : this.$route.name == 'payin'}">
          <a class="waves-effect waves-cyan pointer" @click="$router.push({path:'/app/payin'})">
            <i class="material-icons">attach_money</i>
            <span class="menu-title" data-i18n>Pay In</span>
          </a>
        </li>
        <li value="pay_outs" class="bold" :class="{'active' : this.$route.name == 'payouts'}">
          <a @click="$router.push({path:'/app/payouts'})" class="waves-effect waves-cyan pointer">
            <i class="material-icons">money_off</i>
            <span class="menu-title" data-i18n>Pay Out</span>
          </a>
        </li>
        <li value="support" class="navigation-header">
          <a class="navigation-header-text">Support</a>
          <i class="navigation-header-icon material-icons">more_horiz</i>
        </li>
        <li value="faqs" class="bold" :class="{'active' : this.$route.name == 'faq'}">
          <a class="waves-effect waves-cyan pointer" @click="$router.push({path:'/app/faq'})">
            <i class="material-icons">help</i>
            <span class="menu-title" data-i18n>FAQ</span>
          </a>
        </li>
        <li
          value="issue_tickets"
          class="bold"
          :class="{'active' : (this.$route.name == 'issue-tickets' || this.$route.name == 'issue-detail')}"
        >
          <a
            @click="$router.push({path:'/app/issue-tickets'})"
            class="waves-effect waves-cyan pointer"
          >
            <i class="material-icons">receipt</i>
            <span class="menu-title" data-i18n>Issue Tickets</span>
          </a>
        </li>
        <li value="manage_users" class="navigation-header">
          <a class="navigation-header-text">User</a>
          <i class="navigation-header-icon material-icons">more_horiz</i>
        </li>
        <li
          value="manage_users"
          class="bold"
          :class="{'active' : this.$route.name == 'manage-users'}"
        >
          <a
            class="waves-effect waves-cyan pointer"
            @click="$router.push({path:'/app/manage-users'})"
          >
            <i class="material-icons">supervisor_account</i>
            <span class="menu-title" data-i18n>Manage Users</span>
          </a>
        </li>
        <!-- <li class="navigation-header">
          <a class="navigation-header-text">Profile</a>
          <i class="navigation-header-icon material-icons">more_horiz</i>
        </li>
        <li class="bold">
          <a
            class="waves-effect waves-cyan pointer"
            @click="$router.push({path:'/change-password'})"
          >
            <i class="material-icons">lock</i>
            <span class="menu-title" data-i18n>Change Password</span>
          </a>
        </li>
        <li class="bold">
          <a class="waves-effect waves-cyan pointer" @click="logout()">
            <i class="material-icons">keyboard_tab</i>
            <span class="menu-title" data-i18n>Logout</span>
          </a>
        </li>-->
      </ul>
      <div class="navigation-background"></div>
      <a
        class="sidenav-trigger btn-sidenav-toggle btn-floating btn-medium waves-effect waves-light hide-on-large-only"
        href="#"
        data-target="slide-out"
      >
        <i class="material-icons">menu</i>
      </a>
    </aside>
    <div :id="!showFullNav ? 'main':'main-full'" style="height:calc(100% - 64px)">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showFullNav: false
    };
  },
  created() {
    if (JSON.parse(localStorage.homecare_admin_auth).persona == "sub_admin")
      this.getUserPermissions();
  },
  methods: {
    getUserPermissions() {
      ajax.get(
        Constants.default.APIURL.MyPermissions,
        res => {
          localStorage.setItem(
            "homecare_admin_permissions",
            JSON.stringify(res.data)
          );
        },
        err => {}
      );
    },
    logout() {
      if (localStorage.homecare_admin_auth) {
        let token = JSON.parse(localStorage.homecare_admin_auth).access_token;
        localStorage.clear();
        sessionStorage.clear();
        this.$router.push({
          path: "/login"
        });
        navigator.serviceWorker
          .getRegistrations()
          .then(function(registrations) {
            for (let registration of registrations) {
              registration.unregister();
            }
          });
        ajax.logout(
          Constants.default.APIURL.Logout,
          token,
          res => {},
          err => {}
        );
      }
    },
    toggleFullScreen() {
      if (
        (document.fullScreenElement && document.fullScreenElement !== null) ||
        (!document.mozFullScreen && !document.webkitIsFullScreen)
      ) {
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        } else if (document.documentElement.msRequestFullscreen) {
          if (document.msFullscreenElement) {
            document.msExitFullscreen();
          } else {
            document.documentElement.msRequestFullscreen();
          }
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    }
  },
  mounted() {
    let userDetails = JSON.parse(localStorage.homecare_admin_auth);
    let permissions = userDetails.permissions;
    if (userDetails.persona == "superuser" && permissions.length == 0) {
      return;
    }
    let temp = "";
    if (
      permissions.indexOf("service_category") >= 0 ||
      permissions.indexOf("manage_services") >= 0
    ) {
      permissions.push("services");
    }
    if (
      permissions.indexOf("packages") >= 0 ||
      permissions.indexOf("audits") >= 0 ||
      permissions.indexOf("bookings") >= 0 ||
      permissions.indexOf("reviews") >= 0
    ) {
      permissions.push("service_bookings");
    }
    if (
      permissions.indexOf("faqs") >= 0 ||
      permissions.indexOf("issue_tickets") >= 0
    ) {
      permissions.push("support");
    }
    if (
      permissions.indexOf("pay_ins") >= 0 ||
      permissions.indexOf("pay_outs") >= 0
    ) {
      permissions.push("payments");
    }
    let list = document.querySelectorAll(".sidenav li[value]");
    for (var cnt = 0; cnt < list.length; cnt++) {
      list[cnt].style.display = "none";
    }
    setTimeout(() => {
      $(".sidenav li[value]").each((key, dom) => {
        temp = $(dom).attr("value");
        if (permissions.indexOf(temp) >= 0) {
          $(dom).show();
        } else {
          $(dom).remove();
        }
      });
    }, 500);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


<style lang="scss" scoped>
@import "./../../public/assets/css/pages/dashboard.css";
</style>
